frappe.ui.form.ControlCheck = class ControlCheck extends frappe.ui.form.ControlData {
	static html_element = "input";
	static input_type = "checkbox";
	// make_wrapper() {
	// 	const $row = this.parent?.closest('.grid-row');
	// 	const is_first_row = $row?.attr('data-idx') === '1';
	// 	const is_even_row = this.parent?.closest('.even-row') !== null;
	// 	const isMobile = window.matchMedia("(max-width: 767px)").matches;
	// 	const wrapperClass = is_even_row ? "even-bg" : "odd-bg";

	// 	if ($row && !isMobile) {
	// 		// Standard form-control layout like Data fields
	// 		this.$wrapper = $(`
	// 		<div class="frappe-control input-max-width" style="width:100% ;pointer-events: none;" data-fieldtype="Check" data-fieldname=${this.df.fieldname}>

	// 			<div class="clearfix check-row">
	// 				<label class="control-label" style="${is_first_row ? 'display: block;' : 'color:transparent;'}">${__(this.df.label || "")}</label>
	// 				<span class="help"></span>
	// 			</div>
	// 				<div class="control-input-wrapper ${wrapperClass}" style="padding: 3.5px 1px;">
	// 			<label>
	// 				<span class="input-area" style="pointer-events: auto;"></span>
	// 				<span class="disp-area"></span>
	// 				<span class="ml-1 help"></span>
	// 			</label>
	// 				<p class="help-box small text-muted"></p>
	// 			</div>

	// 		</div>
	// 	`).appendTo(this.parent);
	// 	} else {
	// 		// Keep default structure
	// 		this.$wrapper = $(`
	// 		<div class="form-group frappe-control">
	// 			<div class="checkbox" style="padding-left: 5px;">
	// 				<label>
	// 					<span class="input-area"></span>
	// 					<span class="disp-area"></span>
	// 					<span class="label-area"></span>
	// 					<span class="ml-1 help"></span>
	// 				</label>
	// 				<p class="help-box small text-muted"></p>
	// 			</div>
	// 		</div>
	// 	`).appendTo(this.parent);
	// 	}
	// }
	make_wrapper() {
		const $row = this.parent?.closest('.grid-row');
		const idx = parseInt($row?.attr('data-idx') || '0', 10);
		const is_even_row = idx % 2 === 0;
		const isMobile = window.matchMedia("(max-width: 767px)").matches;

		if ($row && !isMobile) {
			this.$wrapper = $(`
			<div class="frappe-control input-max-width" style="width:100%; pointer-events: none;" data-fieldtype="Check" data-fieldname="${this.df.fieldname}">
				<div class="control-input-wrapper" style="padding: 3.5px 1px; background: ${is_even_row ? 'transparent' : 'white'};">
					<label>
						<span class="input-area" style="pointer-events: auto;"></span>
						<span class="disp-area"></span>
						<span class="ml-1 help"></span>
					</label>
					<p class="help-box small text-muted"></p>
				</div>
			</div>
		`).appendTo(this.parent);
		} else {
			// fallback for mobile
			this.$wrapper = $(`
			<div class="form-group frappe-control">
				<div class="checkbox" style="padding-left: 5px;">
					<label>
						<span class="input-area"></span>
						<span class="disp-area"></span>
						<span class="label-area"></span>
						<span class="ml-1 help"></span>
					</label>
					<p class="help-box small text-muted"></p>
				</div>
			</div>
		`).appendTo(this.parent);
		}
	}
	set_input_areas() {
		this.input_area = this.$wrapper.find(".input-area").get(0);
		if (this.only_input) return;

		this.label_area = this.label_span = this.$wrapper.find(".label-area").get(0);
		this.disp_area = this.$wrapper.find(".disp-area").get(0);
	}
	// make_input() {
	// 	super.make_input();
	// 	this.$input.removeClass("form-control");

	// 	// 🧠 Add label only if inside a grid (child table)
	// 	if (this.df.in_list_view && this.df.label) {
	// 		console.log(this.df)
	// 		// This will ensure column header uses the label
	// 		this.df._has_label_override = true;
	// 	}
	// }
	make_input() {
		super.make_input();
		this.$input.removeClass("form-control");

		if (this.df.in_list_view) {
			this.$input.appendTo(this.$wrapper.find('.control-input'));
		} else {
			this.set_input_areas();
			this.$input.appendTo($(this.input_area));
		}
	}
	get_input_value() {
		return this.input && this.input.checked ? 1 : 0;
	}
	validate(value) {
		return cint(value);
	}
	set_input(value) {
		this.last_value = this.value;
		value = cint(value);
		this.value = value;
		if (this.input) {
			this.input.checked = value ? 1 : 0;
		}
		this.set_mandatory(value);
		this.set_disp_area(value);
	}
};
